export default "__VITE_ASSET__c19fd5c2__"